


<div class="cofirm-scores-container">

    <h3>Socket Device Debug Info</h3>

    <div mat-dialog-content>

        
        <!-- <div>
            Browser: {{ data.data.name }}
        </div>

        <div>
            Browser Version: {{ data.data.version }}
        </div>        

        <div>
            OS Name: {{ data.data.os }}
        </div>   

        <div>
            Platform: {{ data.data.platform }}
        </div>  

        <div>
            Vendor: {{ data.data.vendor }}
        </div>                   -->

        <pre>
            {{ data | json }}
        </pre>
       

    </div>

    <div mat-dialog-actions style="text-align: right;">
        <button mat-raised-button [mat-dialog-close]="false">CLOSE</button>
    </div>

</div>




